/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const audioPartStatusSchema = z.object({
  status: z.enum(['generated', 'skipped', 'failed', 'no_text', 'not_requested']),
  audioUrl: z.string().nullable(),
});

const exampleAudioStatusSchema = audioPartStatusSchema.extend({
  exampleId: z.number(),
});

export const generateAllAudioResultSchema = z.object({
  title: audioPartStatusSchema,
  definition: audioPartStatusSchema,
  usageNotes: audioPartStatusSchema,
  examples: z.array(exampleAudioStatusSchema),
  errors: z.array(z.string()),
});

export type IGenerateAllAudioResult = z.infer<typeof generateAllAudioResultSchema>;

export const generateAllAudioResponseSchema = createApiResponseSchema(
  generateAllAudioResultSchema,
) as z.ZodSchema<IAPI<IGenerateAllAudioResult>>;

export type IGenerateAllAudioResponse = IAPI<IGenerateAllAudioResult>;
